import React from 'react';
import {NavigationContainerRef} from '@react-navigation/native';

import {RootStackParamList} from './RootStackParamList';

export const navigationRef =
  React.createRef<NavigationContainerRef<RootStackParamList>>();
